import { BlockedMatchModalParams, Matchs, Players } from "../../types";

// Pour la création d'un match : doit-il être DOUBLON ?
export function checkMatchCreationBlockedByEnCours(
  matchToCreate: Matchs,
  matchs: Matchs[]
): {
  isBlocked: boolean;
  blockingMatches: Matchs[];
} {
  const blockingMatches = matchs
    .filter((match) => match.status === "ENCOURS")
    .filter((enCoursMatch) =>
      enCoursMatch.matchsPlayerParticipations.some((p) =>
        matchToCreate.matchsPlayerParticipations.some(
          (mp) => mp.playersId === p.playersId
        )
      )
    );
  return { isBlocked: blockingMatches.length > 0, blockingMatches };
}

// Pour le lancement d'un match : quels matchs CREE doivent passer à DOUBLON ?
export function findMatchesToSetDoublonOnLaunch(
  launchedMatch: Matchs,
  matchs: Matchs[]
): Matchs[] {
  return matchs
    .filter((match) => match.status === "CREE")
    .filter((creematch) =>
      creematch.matchsPlayerParticipations.some((p) =>
        launchedMatch.matchsPlayerParticipations.some(
          (mp) => mp.playersId === p.playersId
        )
      )
    );
}

// Ancienne fonction pour compatibilité temporaire (à supprimer si plus utilisée)
const checkIsMatchLaunchable = (
  matchToLaunch: Matchs,
  matchs: Matchs[]
): {
  isMatchLaunchable: boolean;
  blockedMatchModalParams: BlockedMatchModalParams;
} => {
  // Par défaut, on considère la création d'un match
  const { isBlocked, blockingMatches } = checkMatchCreationBlockedByEnCours(
    matchToLaunch,
    matchs
  );
  return {
    isMatchLaunchable: !isBlocked,
    blockedMatchModalParams: {
      blockingPlayers: blockingMatches.map((m) => ({
        player: { id: "", name: "", surname: "" } as Players,
        match: m,
      })),
    },
  };
};

export default checkIsMatchLaunchable;
